<script>
import Section from '../../components/PageSection'
import Spinner from '../../components/Spinner.vue'
import Modale from "../../components/Modale"

import {updateMontant} from '../../mixins/updateMontant.js';
import {allAboutDates} from '../../mixins/allAboutDates.js';


export default {
  name: 'importer',
  components :{
    Section,
    Spinner,
    Modale,
  },
  data(){
    return{
      steps: [
        {ref:0, name:"Vérifications préliminaires"},
        {ref:1, name:"Premières listes"},
        {ref:2, name:"Labels des phases"},
        {ref:3, name:"Projets et contrats"},
        {ref:4, name:"Factures"},
        {ref:5, name:"Utilisateurs"},
        {ref:6, name:"Temps passés"},
        {ref:7, name:"Notes de frais"},
        {ref:8, name:"Prestations extérieures"},
      ],
      step: 0,
      stepMax: 0,
      agences: [],
      agenceId: "",
      loading: false,
      errors: [],
      facturesCount: 0, //Truc temporaire pour compter combien de factures sont envoyées en BDD, un genre de barre de chargement.
      linesCount: 0, //Truc temporaire pour compter combien de lignes sont envoyées en BDD, un genre de barre de chargement.

      //Tableaux pour stocker mes infos JSON avec le lien bound ainsi que les infos créées dans la base de données
      nonFact: [],
      absences: [],
      frais: [],
      phasesLabels: [],
      contractualises: [],
      projets: [],
      contrats: [],
      phases: [],
      factureLines: [],
      salaireUsers: [],
      users: [],
      tempsFraisPrestas: [],
      temps: [],
      ndf: [],
      ndp: [],


      //Tableaux pour stocker les infos existantes de l'application
      nonFactApp: [],
      absencesApp: [],
      fraisApp: [],
      phasesLabelsApp: [],
      rolesApp: [],

      //Tableaux pour stocker les infos à créer et à ajouter en BDD
      nonFactNew: [],
      absencesNew: [],
      fraisNew: [],
      phasesLabelsNew: [],

      //Modales
      modaleInfos: {},
      isModaleProjetVisible: false,

    }
  },
  mixins:[updateMontant, allAboutDates],

  async mounted(){
    const promiseAgences = this.$axios.get('agences')
    .then(response => this.agences = response.data)
    .catch(err => console.log(err))

    // const promiseNonFact = this.$axios.get('nonFact/unflagged/' + this.agenceId)
    // .then(response => this.nonFactApp = response.data)
    // .catch(err => console.log(err))

    await Promise.all([promiseAgences])

  },
  computed:{
    computedOffset(){
      let offset = this.step * -100
      let myString = offset.toString() + '%'
      return myString
    },
    computedProjets(){
      let myArray = []

      for (let item of this.contractualises){
        if (myArray.find(e => e.name == item.nomProjet) == undefined){
          let newProjet = {
            name : item.nomProjet,
            montant : item.montant,
            localisation: item.localisation
          }
          myArray.push(newProjet)
        } else {
          myArray.find(e => e.name == item.nomProjet).montant += item.montant
        }
      }

      return myArray
    },
    computedProjetsFactured(){
      let myArray = []

      for (let item of this.factureLines){
        if (myArray.find(e => e.name == item.nomProjet) == undefined){
          let newProjet = {
            name : item.nomProjet,
            montant : item.montant
          }
          myArray.push(newProjet)
        } else {
          myArray.find(e => e.name == item.nomProjet).montant += item.montant
        }
      }

      return myArray
    },
    computedTempsParProjet(){ //Plutôt par phases de projets en fait
      let myArray = [] //Je vais mettre une proppriété _id qui regroupe phaseId, nonfactIf et absenceId
        for (let line of this.temps){
          if (line.phaseId){
            //C'est une phase
            if (myArray.find(e => e._id == line.phaseId)){
              //Cette phase existe déjà dans le tableau, j'ajoute les temps
              myArray.find(e => e._id == line.phaseId).heures += line.heures
              myArray.find(e => e._id == line.phaseId).jours += line.jours
            } else {
              //Cette phase n'existe pas, je la crée
              let currentPhase = this.phases.find(e => e._id == line.phaseId)
              myArray.push({
                _id     : line.phaseId,
                projet  : this.projets.find(e => e._id == currentPhase.projetId).name,
                phase   : this.phasesLabels.find(e => e.bound == currentPhase.phaseLabelId).nom,
                jours   : line.jours,
                heures  : line.heures,
              })
            }
          } else if (line.nonfactId){
            //C'est une tâche non facturable
            if (myArray.find(e => e._id == line.nonfactId)){
              //Cette tâche existe déjà dans le tableau, j'ajoute les temps
              myArray.find(e => e._id == line.nonfactId).heures += line.heures
              myArray.find(e => e._id == line.nonfactId).jours += line.jours
            } else {
              //Cette tâche n'existe pas, je la crée
              myArray.push({
                _id     : line.nonfactId,
                projet  : "Tâches non facturables",
                phase   : this.nonFact.find(e => e.bound == line.nonfactId).nom,
                jours   : line.jours,
                heures  : line.heures,
              })
            }
            
          } else if (line.absenceId){
            //C'est une absence
            if (myArray.find(e => e._id == line.absenceId)){
              //Cette absence existe déjà dans le tableau, j'ajoute les temps
              myArray.find(e => e._id == line.absenceId).heures += line.heures
              myArray.find(e => e._id == line.absenceId).jours += line.jours
            } else {
              //Cette absence n'existe pas, je la crée
              myArray.push({
                _id     : line.absenceId,
                projet  : "Absences",
                phase   : this.absences.find(e => e.bound == line.absenceId).nom,
                jours   : line.jours,
                heures  : line.heures,
              })
            }
          }
        }
      return myArray
    },
    computedTempsParUser(){
      let myArray = []

      for (let line of this.temps){
        //Est-ce que cet user existe déjà ?
        if (myArray.find(e => e.userId == line.userId)){
          //L'user existe déjà, j'ajoute les temps
          myArray.find(e => e.userId == line.userId).heures += line.heures
          myArray.find(e => e.userId == line.userId).jours += line.jours
        } else {
          //L'user n'existe pas, je le crée
          let currentUser = this.users.find(e => e._id == line.userId)
          if (currentUser){
            myArray.push({
              userId  : line.userId,
              name    : currentUser.name + " " + currentUser.surname,
              jours   : line.jours,
              heures  : line.heures,
            }) 
          } else {
            myArray.push({
              name    : "User inconnu !!",
              jours   : 0,
              heures  : 0,
            })
          }
          
        }
      }
      
      return myArray
    },
    computedTotal(){
      return {
        heuresProjets : this.computedTempsParProjet.reduce((acc, val) => acc + val.heures, 0),
        joursProjets  : this.computedTempsParProjet.reduce((acc, val) => acc + val.jours, 0),
        heuresUsers   : this.computedTempsParUser.reduce((acc, val) => acc + val.heures, 0),
        joursUsers    : this.computedTempsParUser.reduce((acc, val) => acc + val.jours, 0),
      }
    },
    computedNdf(){
      let myArray = []
        for (const line of this.ndf) {
          let currentPhase = this.phases.find(e => e._id == line.phaseId)

          myArray.push({
            date    : new Date(Date.parse(line.date)),
            projet  : this.projets.find(e => e._id == currentPhase.projetId).name,
            phase   : this.phasesLabels.find(e => e.bound == currentPhase.phaseLabelId).nom,
            type    : line.labelId,
            objet   : line.objet,
            montant : line.montantHT,
          })
        }
      return myArray
    },
    computedNdp(){
      let myArray = []
        for (const line of this.ndp) {
          let currentPhase = this.phases.find(e => e._id == line.phaseId)

          myArray.push({
            date    : new Date(Date.parse(line.date)),
            projet  : this.projets.find(e => e._id == currentPhase.projetId).name,
            phase   : this.phasesLabels.find(e => e.bound == currentPhase.phaseLabelId).nom,
            type    : line.labelId,
            objet   : line.objet,
            montant : line.montantHT,
          })
        }
      return myArray
    },
  },
  methods:{
    clickToStep(e){
      //Vérifier s'il a le droit d'aller à ce step là. Qu'il ne puisse pas avancer trop.
      if (e <= this.stepMax){
        this.step = e;
      }
    },

    async pageValidation(ref){
      switch (ref){
        case 0 :{
          //On charge toutes les infos de cette agence, ses types de non facturables, ses types d'absences, etc.
          if (this.agenceId != ""){
            this.loading = true

            const promiseNonFact = this.$axios.get('nonFact/unflagged/' + this.agenceId)
            .then(response => this.nonFactApp = response.data)
            .catch(err => console.log(err))

            const promiseAbsences = this.$axios.get('absences/unflagged/' + this.agenceId)
            .then(response => this.absencesApp = response.data)
            .catch(err => console.log(err))

            const promiseFrais = this.$axios.get('frais/unflagged/' + this.agenceId)
            .then(response => this.fraisApp = response.data)
            .catch(err => console.log(err))

            const promisePhasesLabels = this.$axios.get('phaseLabels//getAllUnflagged/' + this.agenceId)
            .then(response => this.phasesLabelsApp = response.data)
            .catch(err => console.log(err))

            const promiseRoles = this.$axios.get('roles/getByAgence/' + this.agenceId)
            .then(response => this.rolesApp = response.data)

            await Promise.all([promiseNonFact, promiseAbsences, promiseFrais, promisePhasesLabels, promiseRoles])
            this.loading = false

            this.step++
            this.stepMax = this.step
          }
        } break;

        case 1 :{
          this.errors = []

          //Vérifier que tous les éléments importés en JSON ai bien une id liée
          let allFilled = true
          for (let item of this.nonFact){
            allFilled = ((item.bound === "") ? false : allFilled)
          }
          for (let item of this.absences){
            allFilled = ((item.bound === "") ? false : allFilled)
          }
          for (let item of this.frais){
            allFilled = ((item.bound === "") ? false : allFilled)
          }

          if (allFilled){
            let allArrays = ['nonFact', 'absences', 'frais']

            for (let myArray of allArrays){

              //Ajouter les nouveaux labels en BDD
              for (let item of this[myArray]){
                if (this[myArray + 'App'].find(e => e._id == item.bound) == undefined){

                  if (this[myArray + 'New'].find(e => e._id == item.bound)){
                    //Définition de la nouvelle tâche non facturable / absence ou frais
                    let tache = {
                      agenceId: this.agenceId,
                      name: this[myArray + 'New'].find(e => e._id == item.bound).name,
                      rank: this[myArray + 'App'].length,
                    };

                    //Ajout à la BDD
                    await this.$axios.post(myArray + '/register', tache)
                    .then(response => {
                      console.log(response)
                      switch (myArray){
                        case 'nonFact': tache._id = response.data.tacheId
                          break;
                        case 'absences': tache._id = response.data.absenceId
                          break;
                        case 'frais': tache._id = response.data.fraisId
                          break;
                      }

                      //J'ajoute cette nouvelle tâche à celles de l'application
                      this[myArray + 'App'].push(tache)

                      //Je met à jour cet élément et tous les autres éléments JSON qui ont été liés à cette tache
                      let oldBound = item.bound
                      for (let otherNF of this[myArray]){
                        if (otherNF.bound == oldBound){
                          otherNF.bound = tache._id
                        }
                      }
                    })
                    .catch(err => {
                      console.log(err)
                      this.errors.push("erreur dans l'ajout en BDD")
                    })

                  } else {
                    this.errors.push("Pas d'id correspondant dans les nouveaux éléments créés")
                  }
                }
              }
            }
  
            this.step++
            this.stepMax = this.step

          } else {
            this.errors.push("Certaines valeurs n'ont pas de liaison.")
          }

            

        } break;

        case 2 :{
          this.errors = []



          //Tout ce qui est commenté en suivant marche très bien, mais pour gérer le bazar blp on va pas se prendre la tête. J'ai tout mis dans fromBLPtoSPHEM
          //Supprimer ces 2 lignes qui ne concernent que l'import blp
          this.step++
          this.stepMax = this.step
          

          //A CONSERVER !!! ÇA FONCTIONNE BIEN MAIS POUR GERER LE BAZAR BLP JE FAIS AUTREMENT
          // //Vérifier que tous les éléments importés en JSON ai bien une id liée
          // let allFilled = true
          // for (let item of this.phasesLabels){
          //   allFilled = ((item.bound === "") ? false : allFilled)
          // }

          // if (allFilled){
          //   //Ajouter les nouveaux labels en BDD
          //   for (let item of this.phasesLabels){
          //     if (this.phasesLabelsApp.find(e => e._id == item.bound) == undefined){

          //       if (this.phasesLabelsNew.find(e => e._id == item.bound)){
          //         //Définition du nouveau label
          //         let label = {
          //           agenceId: this.agenceId,
          //           name: this.phasesLabelsNew.find(e => e._id == item.bound).name,
          //           type: this.phasesLabelsNew.find(e => e._id == item.bound).type,
          //           rank: this.phasesLabelsNew.find(e => e._id == item.bound).rank,
          //         };

          //         //Ajout à la BDD
          //         await this.$axios.post('phaseLabels/register', label)
          //         .then(response => {
          //           console.log(response)
          //           label._id = response.data.phaseId

          //           //J'ajoute ce nouveau label à ceux de l'application
          //           this.phasesLabelsApp.push(label)

          //           //Je met à jour cet élément et tous les autres éléments JSON qui ont été liés à cette tache
          //           let oldBound = item.bound
          //           for (let otherNF of this.phasesLabels){
          //             if (otherNF.bound == oldBound){
          //               otherNF.bound = label._id
          //             }
          //           }
          //         })
          //         .catch(err => {
          //           console.log(err)
          //           this.errors.push("erreur dans l'ajout en BDD")
          //         })

          //       } else {
          //         this.errors.push("Pas d'id correspondant dans les nouveaux éléments créés")
          //       }
          //     }
          //   }

          //   this.step++
          //   this.stepMax = this.step
          // } else {
          //   this.errors.push("Pas d'id correspondant dans les nouveaux éléments créés")
          // }
          

        } break;

        case 3 :{
          this.loading = true

          //A partir du fichier JSON (et du computed qui le simplifie), créer les projets
          for (let item of this.computedProjets){
            let projet = {
              name: item.name,
              agenceId: this.agenceId,
              active: true,
              deleted: false,
              date: Date.now(),
              localisation: item.localisation,
            }

            await this.$axios.post('projets', projet)
            .then(async response => {
              //J'ajoute le nouveau projet dans this.projets pour l'utiliser plus tard avec sa nouvelle _id
              projet._id = response.data.projetId;
              this.projets.push(projet);
              //Je crée un contrat de marché initial associé à ce projet (pas de prise en charge des avenants pour l'instant)
              let contrat = {
                agenceId: this.agenceId,      // A quelle agence appartient cet élément
                projetId: projet._id,         // Le projet auquel il appartient
                date: Date.now(),             // La date de signature du contrat, par défaut la date de création du projet dans l'application
                name: "Marché initial"        // Le nom du contrat
              }
              await this.$axios.post('contrats/register', contrat)
              .then(res => {
                this.contrats.push(res.data.contrat)
              })
              .catch(err => this.alert(err))
            })
            .catch(err => this.alert(err));
          }

          // Puis à partir du JSON (chargé dans this.contractualise), créer les phases du projet
          let promises = []
          for (let item of this.contractualises){
            let phase = {
              agenceId:     this.agenceId,
              phaseLabelId: this.phasesLabels.find(e => e.nom == item.nomPhase).bound,
              projetId:     this.projets.find(e => e.name == item.nomProjet)._id,
              type:         this.phasesLabelsApp.find(e => e._id == this.phasesLabels.find(e => e.nom == item.nomPhase).bound).type,
            }

            promises.push(
              this.$axios.post('phases/register', phase)
              .then(response => {
                //J'ajoute l'Id reçu de serveur à mon objet Phase en local pour l'ajouter à mon client
                phase._id = response.data.phaseId;
                this.phases.push(phase);

                //Je complète contractualise en local et je l'envoie en BDD
                item.agenceId  = this.agenceId
                item.projetId  = phase.projetId
                item.contratId = this.contrats.find(e => e.projetId == item.projetId)._id
                item.phaseId   = phase._id

                this.$axios.post('contractualise/register', item)
                .then(res =>{
                  //J'ajoute l'id à l'objet
                  item._id = res.data.contractualiseId
                  })
                .catch(err => this.alert(err))
              })
              .catch(err => this.alert(err))
            )
          }

          await Promise.all(promises)
          
          this.step++
          this.stepMax = this.step
          this.loading = false
        } break;

        case 4 :{
          let arrayOfPromises = []
          this.loading = true

          if (this.errors.length == 0){
            //Pour chaque ligne de facturation...
            for (let line of this.factureLines){
              // ... Créer une facture (une ligne = une facture) en BDD
              let newFact = {
                agenceId  : this.agenceId,
                projetId  : line.projetId,
                date      : line.date,
                numero    : line.numero,
              }

              //Envoi de la facture au serveur
              arrayOfPromises.push(
                this.$axios.post('factures/register', newFact)
                .then(async response => {

                  //Ajout de l'id de l'objet nouvellement créé par le serveur pour pouvoir manipuler l'objet depuis le client
                  line.factureId = response.data.factureId
                  this.facturesCount ++
                })
                .catch(err => {
                  this.alert(err)
                  this.errors.push(err)
                })
              )
            }

            await Promise.all(arrayOfPromises)
            arrayOfPromises = []

            for (let line of this.factureLines){
              // ... Créer la ligne de facture en BDD
              let newLine = {
                agenceId    : this.agenceId,
                factureId   : line.factureId,
                phaseId     : line.phaseId,
                pourcentage : line.pourcentage,
                montant     : line.montant,
                tva         : line.tva,
              }

              arrayOfPromises.push(
                this.$axios.post('factureLines/registerLight/' + this.agenceId, newLine)
                .then(() => {
                  this.linesCount ++
                })
                .catch(err => {
                  console.log(err)
                  this.errors.push(err)
                })
              )
            }

            await Promise.all(arrayOfPromises)

                  

            // //Toutes mes factures sont en BDD, j'ai récupéré leurs ID pour faire un tableau avec des lignes complètes. J'envoi le tableau d'un seul coup. Faire les reggister un par un sur les lignes prends 1,5 secondes à chaque ligne...
            // await this.$axios.post('factureLines/registerArray/' + this.agenceId, arrayOfLines)
            // .then(res => {
            //   this.linesCount ++
            //   console.log(res)
            // })
            // .catch(err => {
            //   console.log(err)
            //   this.errors.push(err)
            // })
          }
          
          //Exemple de try / catch
          // try {
          //   //Pour chaque ligne de facturation...
          //   for (let line of this.factureLines){
          //     //... Ajouter un projetId
          //     if (this.projets.find(e => e.name == line.nomProjet) == undefined){throw "Pas de projet correspondant (" + line.nomProjet + ")"}
          //     line.projetId = this.projets.find(e => e.name == line.nomProjet)._id
          //   }
          // } catch (error) {
          //   this.alert(error)
          //   this.errors.push(error)
          // }

          this.loading = false

          if (this.errors.length == 0){
            this.step++
            this.stepMax = this.step
          }
        } break;

        case 5 :{
          if (this.errors.length == 0){
            let arrayOfPromises = []
            let usersInApp = []

            //Récupérer les users déjà existants
            arrayOfPromises.push(this.$axios.get('users/allInAgence/' + this.agenceId)
            .then(res => {
              usersInApp = res.data
            })
            .catch(err => {
              this.errors.push(err)
            }))

            
            //Ajouter chaque nouvel utilisateur
            for (let user of this.users){
              //Générer un mot de passe : les 3 premières lettres du prénom directement suivies des 3 premières lettres du nom, le tout en minuscules. Si le nom ou le prénom est plus court, se contenter des une ou deux lettres.
              user.password = user.name.slice(0, 3).toLowerCase() + user.surname.slice(0, 3).toLowerCase()

              //Envoyer en BDD
              arrayOfPromises.push(this.$axios.post('users/register', user)
              .then(response => {
                //Je lui ajoute la propriété _id communiquée dans la response du server
                user._id = response.data.userId;
              })
              .catch(e => {
                console.log(e)
                // this.errors.push(e)
                this.alert("erreur : " + user.name + " " + user.surname)
              }))
            }

            await Promise.all(arrayOfPromises)

            //Fusionner sur le client les nouveaux utilisateurs avec ceux déjà présents dans l'application
            this.users = this.users.concat(usersInApp)

            this.alert(usersInApp.length + " utilisateurs existants récupérés en plus")

            if (this.errors.length == 0){
              this.step++
              this.stepMax = this.step
            }
          }
        } break;

        case 6 :{
          if (this.errors.length == 0){
            this.linesCount = 0
            this.loading = true
            let arrayOfPromises = []

            //Envoyer chaque temps dans la BDD correspondante (jours ou heures)
            for (const line of this.temps) {
              let time = {
                agenceId  : this.agenceId,
                userId    : line.userId,
                date      : Date.parse(line.date) + 12 * (3600000), //Je rajoute 12 heures pour rattraper les question de GTM+1, donc si j'ai des clients au quebec potentiellement c'est la merde...
                volume    : 0,
              }

              if (line.nonfactId){time.nonfactId = line.nonfactId}
              if (line.absenceId){time.absenceId = line.absenceId}
              if (line.phaseId){time.phaseId = line.phaseId}              

              if (line.jours){
                time.volume = line.jours
                //Envoi en BDD jours
                arrayOfPromises.push(this.$axios.post('tempsJours/register', time)
                .then(() => {
                  this.linesCount ++
                })
                .catch(err => {
                  console.log(err)
                  this.errors.push(err)
                }))
              }
              if (line.heures){
                time.volume = line.heures
                //Envoi en BDD heures
                arrayOfPromises.push(this.$axios.post('tempsHeures/register', time)
                .then(() => {
                  this.linesCount ++
                })
                .catch(err => {
                  console.log(err)
                  this.errors.push(err)
                }))
              }
            }

            await Promise.all(arrayOfPromises)
            this.loading = false

            if (this.errors.length == 0){
              this.step++
              this.stepMax = this.step
            } else {
              alert(this.errors.length + " erreurs !")
            }
          }
        } break;

        case 7 :{
          if (this.errors.length == 0){
            this.linesCount = 0
            this.loading = true
            let arrayOfPromises = []

            //Envoyer les notes de frais en base de données
            for (const line of this.ndf) {
              let nd = {
                agenceId  : this.agenceId,
                labelId   : line.labelId,
                phaseId   : line.phaseId,
                objet     : line.objet,
                montantHT : line.montantHT,
                date      : Date.parse(line.date) + 12 * (3600000), //Je rajoute 12 heures pour rattraper les question de GTM+1, donc si j'ai des clients au quebec potentiellement c'est la merde...,
              }

              arrayOfPromises.push(
                this.$axios.post('ndf/register', nd)
                .then(() => this.linesCount ++)
                .catch(err => {
                  console.log(err)
                  this.errors.push(err)
                })
              )
            }
            
            await Promise.all(arrayOfPromises)
            this.loading = false

            if (this.errors.length == 0){
              this.step++
              this.stepMax = this.step
            } else {
              alert(this.errors.length + " erreurs !")
            }
          }
        } break;

        case 8 :{
          if (this.errors.length == 0){
            this.linesCount = 0
            this.loading = true
            let arrayOfPromises = []

            //Envoyer les prestations extérieures en base de données
            for (const line of this.ndp) {

              let nd = {
                agenceId  : this.agenceId,
                labelId   : line.labelId,
                phaseId   : line.phaseId,
                objet     : line.objet,
                montantHT : line.montantHT,
                date      : Date.parse(line.date) + 12 * (3600000), //Je rajoute 12 heures pour rattraper les question de GTM+1, donc si j'ai des clients au quebec potentiellement c'est la merde...
              }

              arrayOfPromises.push(this.$axios.post('ndp/register', nd)
              .then(() => this.linesCount ++)
              .catch(err => {
                  console.log(err)
                  this.errors.push(err)
                }))
            }
            
            await Promise.all(arrayOfPromises)
            this.loading = false

            if (this.errors.length == 0){
              alert("Importation terminée !! Bravo !!")
            } else {
              alert(this.errors.length + " erreurs !")
            }
          }
        } break;
      }
    },

    //Charger un fichier JSON
    loadFile(evt, arrayName){
      this.errors = []
      let myArray = []
      this[arrayName] = []

      let fileReader = new FileReader();
      fileReader.onload = e => {
        myArray = JSON.parse(e.target.result)
    
        let i = 0
        for (let item of myArray){
          item.bound = ""
          this.$set(this[arrayName], i, item)
          i++
        }

        //Après certains chargement, il est nécessaire de faire quelques actions (par exemple dispatcher un fichier Json dans plusieurs tableaux)
        switch (arrayName){
          case 'contractualises':{ //extraire les données de contractualise pour remplir les phases Labels.
            
            //Spécial BLP : formatage de this.contractualise au bon format, parceque je ne l'ai pas fait avec excel VBA
            this.fromBLPtoSPHEM()
            
            //Cette boucle est bonne, à réactiver quand j'enlève les spécificités BLP
            // for(let item of this.contractualises){
            //   if (this.phasesLabels.find(e => e.nom == item.nomPhase) == undefined){
            //     this.phasesLabels.push({nom: item.nomPhase, bound: ""})
            //   }
            // }
            break;
          }
          case 'factureLines':{

            //Spécial BLP
            this.fromBLPtoSPHEMfactures()

            try {
              //Pour chaque ligne de facturation...
              for (let line of this.factureLines){
                //... Ajouter un projetId
                if (this.projets.find(e => e.name == line.nomProjet) == undefined){
                  let err = "Pas de projet correspondant (" + line.nomProjet + ")"
                  if (this.errors.indexOf(err) == -1){
                    this.errors.push(err)
                  }
                } else {
                  line.projetId = this.projets.find(e => e.name == line.nomProjet)._id

                  //... Ajouter un phaseId
                  let phaseLabelId = ""
                  if (this.phasesLabels.find(e => e.nom == line.nomPhase) != undefined){
                    if (this.phasesLabels.find(e => e.nom == line.nomPhase).bound != ""){
                      phaseLabelId = this.phasesLabels.find(e => e.nom == line.nomPhase).bound
                    } else {
                      this.errors.push("Pas de bound pour " + line.nomPhase)  
                    }
                  } else {
                    this.errors.push("Pas de label correspondant (" + line.nomProjet + " - " + line.nomPhase + ")")
                  }
                  
                  let phaseCorrespondante = this.phases.find(e => e.phaseLabelId == phaseLabelId && e.projetId == line.projetId)

                  if (phaseCorrespondante == undefined){
                    this.errors.push("Pas de phase correspondante (" + line.nomProjet + " - " + line.nomPhase + ")")
                  } else {
                    line.phaseId = phaseCorrespondante._id

                    //... Calculer le pourcentage
                    try {
                      let totalPhase = this.contractualises.find(e => e.phaseId == line.phaseId).montant
                      line.pourcentage = (line.montant / totalPhase * 100).toFixed(0)
                    } catch (error) {
                      this.alert(error)
                      this.errors.push(error)
                      line.pourcentage = "erreur..." 
                    }
                  }
                }

                //... Convertir la date en date (c'est une string après import)
                line.date = this.factureDate(line.date, "/")

              }
            } catch (error) {
              this.alert(error)
            }

            break;
          }
          case 'salaireUsers':{
            this.errors = []
            this.users = [] //A chaque fois que je charge un nouveau fichier, j'efface les données précédentes

            this.fromBLPtoSPHEMusers()

            try {
              for (let line of this.salaireUsers){
                if (this.users.find(e => e.email == line.email) == undefined){
                  //Il s'agit d'un nouvel user
                  line.nom = this.capitalize(line.nom.toLowerCase())
                  line.prenom = this.capitalize(line.prenom.toLowerCase())

                  this.users.push({
                    email     : line.email,
                    name      : line.prenom,
                    surname   : line.nom,
                    active    : line.active,
                    agenceId  : this.agenceId,
                    roleId    : this.rolesApp[0]._id,
                    salaire   : [{
                      date: this.factureDate(line.dateSalaire, "/"),
                      val : line.salaire,
                    }],
                  })
                } else {
                  //Il s'agit d'une augmentation
                  this.users.find(e => e.email == line.email).salaire.push({
                    date: this.factureDate(line.dateSalaire, "/"),
                    val : line.salaire,
                  })

                  this.users.find(e => e.email == line.email).salaire.sort((a, b) => a.date - b.date);
                }
              }
              
            } catch (error) {
              this.errors.push(error)
            }
            break;
          }
          case 'tempsFraisPrestas':{
            this.errors = []
            this.temps = [] //A chaque fois que je charge un nouveau fichier, j'efface les données précédentes
            this.ndf = []
            this.ndp = []

            for (let line of this.tempsFraisPrestas){
              try {
                if (line.date != ""){
                //Est-ce que la ligne concerne un projet, du non facturable ou une absence ? Et est-ce que ces éléments ont bien été importés ?
                //Nota : si je veux pouvoir importer des temps dans un projet qui existait avant cette importation, ben aujourd'hui c'est pas prévu. Je dois tout importer d'un bloc.
                  switch (line.projet){
                    case '  ---  Administratif':{
                      //La ligne concerne une tâche non facturable
                      let currentNonFact = this.nonFact.find(e => e.nom == line.phase)
                      if (currentNonFact == undefined){
                        throw "Tâche non facturable inconnue (" + line.phase + ") à la ligne " + line.number
                      } else {
                        if (currentNonFact.bound){
                          line.nonfactId = currentNonFact.bound
                        } else {
                          throw "Pas d'ID pour la tâche non facturable (" + line.phase + ")"
                        }
                      }
                      break;
                    }
                    case ' --- Absences':
                    case '  ---  Absences':{
                      //La ligne concerne une absence
                      let currentAbsence = this.absences.find(e => e.nom == line.phase)
                      if (currentAbsence == undefined){
                        throw "Absence inconnue (" + line.phase + ") à la ligne " + line.number
                      } else {
                        if (currentAbsence.bound){
                          line.absenceId = currentAbsence.bound
                        } else {
                          throw "Pas d'ID pour l'absence (" + line.phase + ")"
                        }
                      }
                      break;
                    }
                    default:{
                      //La ligne concerne un projet
                      let currentProjet = this.projets.find(e => e.name == line.projet.replace(/�/g, "é"))

                      if (currentProjet == undefined){
                        throw "Projet inconnu (" + line.projet + ") à la ligne " + line.number
                      } else {
                        if (currentProjet._id){
                          line.projetId = currentProjet._id
                        } else {
                          throw "Pas d'ID pour le projet (" + line.projet + ")"
                        }

                        //Est-ce que j'ai bien cette phase pour ce projet
                        let phaseLabelId = ""
                        if (this.phasesLabels.find(e => e.nom == line.phase.replace(/�/g, "é"))){
                          phaseLabelId = this.phasesLabels.find(e => e.nom == line.phase.replace(/�/g, "é")).bound
                        } else {
                          throw "Label inconnu (" + line.phase + ") à la ligne " + line.number
                          // this.errors.push("Label inconnu (" + line.phase + ") à la ligne " + line.number)
                        }

                        let currentPhase = this.phases.find(e => e.projetId == line.projetId && e.phaseLabelId == phaseLabelId)
                        if (currentPhase == undefined){
                          throw "Phase inconnue (" + line.phase + ") à la ligne " + line.number
                          // this.errors.push("Phase inconnue (" + line.phase + ") à la ligne " + line.number)
                        } else {
                          if (currentPhase._id){
                            line.phaseId = currentPhase._id
                          } else {
                            throw "Pas d'ID pour la phase (" + line.phase + ")"
                          }
                        }
                      }
                      break;
                    }
                  }
                } else {
                  throw "Pas de date à la ligne " + line.number
                }

                //J'ai validé la date, le projet et la phase > Quid de l'user ? Est-ce que je l'ai bien importé avant ?
                if (line.jours || line.heures){
                  let userName = this.capitalize(line.name.replace(/�/g, "é").toLowerCase())
                  let userSurname = this.capitalize(line.surname.replace(/�/g, "é").toLowerCase())
                  let currentUser = this.users.find(e => e.name == userName && e.surname == userSurname)
                  if (currentUser == undefined){
                    throw "Utilisateur inconnu (" + line.name + " " + line.surname + ") à la ligne " + line.number
                  } else {
                    if (currentUser._id){
                      line.userId = currentUser._id
                    } else {
                      throw "Pas d'ID pour l'utilisateur (" + line.name + " " + line.surname + ")"
                    }
                  }
                }

                //Valider le type de frais
                if (line.ndfEuros){
                  if (!line.ndfType){
                    throw "Pas de type de frais pour la note de frais à la ligne" + line.number
                  } else {
                    let currentFrais = this.frais.find(e => e.nom == line.ndfType) 
                    if (!currentFrais){
                      throw "Type de frais introuvable pour la note de frais à la ligne " + line.number
                    }
                  }
                }
                if (line.ndpEuros){
                  if (!line.ndpType){
                    throw "Pas de type de frais pour la prestation à la ligne" + line.number
                  } else {
                    let currentFrais = this.frais.find(e => e.nom == line.ndpType)
                    if (!currentFrais){
                      throw "Type de frais introuvable pour la prestation à la ligne " + line.number
                    }
                  }
                }

                //La ligne est bonne, je peux la raccrocher aux infos que j'ai déjà, je l'ajoute donc dans le tableau correspondant (temps, ndf ou ndp)
                if (line.jours || line.heures){
                  let newTime = {
                    agenceId  : this.agenceId,
                    userId    : line.userId,
                    date      : line.date,
                    jours     : line.jours,
                    heures    : line.heures,
                  }
                  
                  if (line.nonfactId){newTime.nonfactId = line.nonfactId}
                  if (line.absenceId){newTime.absenceId = line.absenceId}
                  if (line.phaseId  ){newTime.phaseId   = line.phaseId  }

                  this.temps.push(newTime)
                }

                if (line.ndfEuros){
                  this.ndf.push({
                    agenceId  : this.agenceId,
                    labelId   : this.frais.find(e => e.nom == line.ndfType).bound,
                    userId    : line.userId,
                    phaseId   : line.phaseId,
                    objet     : line.ndfObjet,
                    montantHT : line.ndfEuros,
                    date      : line.date,
                  })
                }

                if (line.ndpEuros){
                  this.ndp.push({
                    agenceId  : this.agenceId,
                    labelId   : this.frais.find(e => e.nom == line.ndpType).bound,
                    phaseId   : line.phaseId,
                    objet     : line.ndpObjet,
                    montantHT : line.ndpEuros,
                    date      : line.date,
                  })
                }
              } catch (error) {
                this.errors.push(error)
              }
            }
          }
        }
       
      }

      fileReader.readAsText(evt.target.files[0]);
    },
    showModale(name, infos){
      switch (name) {
        case 'projet':{
          this.modaleInfos = infos
          this.isModaleProjetVisible = true
          break;
        }
      }
    },
    closeModale(){
      this.isModaleProjetVisible = false
      this.modaleInfos = {}
    },
    copyOrigin(ref, value, jsonName){
      //Création d'un nouveau label. Il est d'abord ajouté sur le client, il part en BDD une fois la page validée (Méthode 'pageValidation')
      if (value == this[ref].length){ //Il s'agit donc d'un nouveau label, voir HTML
        let tempID = this[ref].length

        //J'ajoute ce label dans une table temporaire sur le client
        this[ref].push({
          _id: tempID,
          name: jsonName,
        })

        //J'ajoute l'option dans le select pour pouvoir la sélectionner immédiatement
        // let opt = document.createElement('option');
        // opt.value = tempID
        // opt.innerHTML = tempID
        // document.getElementById(jsonName).appendChild(opt);
        // document.getElementById(jsonName).click()

        //document.getElementById(jsonName).value = tempID // Ne fonctionne pas, comme si la ligne 'option' n'était pas encore créée.
        // document.getElementById(jsonName).value = 0


        // newBind = {
        //   jsonName: jsonName,
        //   labelId : tempID,
        // }

      }


      // if (value !== ""){
      //   newBind = {
      //     jsonName: jsonName,
      //     labelId : value,
      //   }

      //   if (this[ref].find(e => e.jsonName == jsonName)){
      //     this[ref].splice(this[ref].findIndex(e => e.jsonName == jsonName), 1, newBind)
      //   } else {
      //     this[ref].push(newBind)
      //   }
      // }
    },
    phaseLabelsByType(type){
      let myArray = this.phasesLabelsApp.filter(e => e.type == type)
      return myArray
    },
    copyPhaseLabel(value, jsonName){
      //Création d'un nouveau label. Il est d'abord ajouté sur le client, il part en BDD une fois la page validée (Méthode 'pageValidation')
      if (value.length == 4){ //Il s'agit donc d'un nouveau label, voir HTML
        let tempID = this.phasesLabelsNew.length

        //J'ajoute ce label dans une table temporaire sur le client
        this.phasesLabelsNew.push({
          _id: tempID,
          name: jsonName,
          type: parseInt(value.slice(3), 10),
          rank: this.phaseLabelsByType(value.slice(3)).length + this.phasesLabelsNew.filter(e => e.type == parseInt(value.slice(3), 10)).length,
        })

        this.phasesLabels.find(e => e.nom == jsonName).bound = tempID
      }
    },
    phasesProjet(projetName){
      let myArray = []

      for (let item of this.contractualises){
        if (item.nomProjet == projetName){
          let newPhase = {
            name : item.nomPhase,
            montant : item.montant
          }
          myArray.push(newPhase)
        }
      }

      return myArray
    },
    facturesLinesByProjet(nomProjet){
      let myArray = this.factureLines.filter(e => e.nomProjet == nomProjet)
      return myArray
    },
    factureDate(string, separateur){
      let myDate = new Date()

      //Le premier élément de la chaîne de caractère est le mois (!)
      let month = string.slice(0, string.indexOf(separateur)) - 1 //0 = Janvier
      string = string.slice(string.indexOf(separateur) + 1)

      //Puis vient le jour
      let day = string.slice(0 , string.indexOf(separateur))

      //Et enfin l'année
      let year = string.slice(string.indexOf(separateur) + 1)

      myDate.setMonth(month)
      myDate.setDate(day)
      myDate.setFullYear(year)

      return myDate
    },
    async fromBLPtoSPHEM(){
      let importFoireux = this.contractualises
      let myArray = []

      for (let j = 0; j < importFoireux.length; j = j + 2) {
        for (let k = 1; k < 40; k++) {
          if (importFoireux[j][k] != ""){
            let contractualise = {
              nomProjet     : importFoireux[j].name.replace(/�/g, "é"),
              nomPhase      : importFoireux[j][k].replace(/�/g, "é"),
              montant       : (importFoireux[j + 1][k] != "") ? parseFloat(importFoireux[j+1][k]) : 0,
              localisation  : importFoireux[j + 1].localisation.replace(/�/g, "é"),
            }

            //ajouter le type du label (0: études, 1: chantier, 2: mission complémentaires)
            if (k < 14) {
              contractualise.type = 0
            } else if (k < 28){
              contractualise.type = 1
            } else {
              contractualise.type = 2
            }

            myArray.push(contractualise)
          }
        }
      }

      this.contractualises = myArray

      //On prend toutes les phases propoposées, on les ajoutes comme un nouveau Phase Label que l'on flag tout de suite en deleted. Ils auront leur ancien bazar sous les yeux, et leurs nouvelles listes bien propres
      //Puisque pour BLP je n'utilise pas la page 2 pour associer les nouveau labels aux anciens, je vais repartir d'un this.phasesLabels tout neuf.
      this.phasesLabels = []

      for (let item of this.contractualises){
        if (this.phasesLabels.find(e => e.nom == item.nomPhase) == undefined){
          //Je défini le label à envoyer en base de données. Il est déjà 'deleted: true'.
          let label = {
            agenceId: this.agenceId,
            name: item.nomPhase,
            type: item.type,
            rank: 0,
            deleted: true,
          }

          //Ajout à la BDD
          await this.$axios.post('phaseLabels/register', label)
          .then(response => {
            label._id = response.data.phaseId

            //J'ajoute ce nouveau label à ceux de l'application
            this.phasesLabelsApp.push(label)

            //Je mets à jours this.phasesLabels avec l'objet + son Id
            this.phasesLabels.push({
              nom: item.nomPhase,
              type: item.type,
              bound: label._id
            })
          })
          .catch(err => {
            console.log(err)
            this.errors.push("erreur dans l'ajout en BDD")
          })
        }
      }

      this.step++
      this.stepMax = this.step
    },
    fromBLPtoSPHEMfactures(){
      for (const item of this.factureLines) {
        item.nomProjet = item.nomProjet.replace(/�/g, "é")
        item.nomPhase = item.nomPhase.replace(/�/g, "é")
        item.tva = 20
        item.date
      }
    },
    fromBLPtoSPHEMusers(){
      let importFoireux = this.salaireUsers
      let myArray = []

      for (let i = 0; i < importFoireux.length; i++) {
        importFoireux[i].prenom = importFoireux[i].prenom.replace(/�/g, "é")
        if (importFoireux[i].email != ""){
          for (let j = 0; j < importFoireux[i].salaire.length; j++) {
            if (importFoireux[i].salaire[j] != null){
              let line = {
                nom         :importFoireux[i].nom,
                prenom      :importFoireux[i].prenom,
                email       :importFoireux[i].email.replace(/�/g, "e"),
                salaire     :importFoireux[i].salaire[j],
                dateSalaire :importFoireux[i].dateSalaire[j],
                active      :importFoireux[i].active,
              }

              myArray.push(line)
            }
          }
        }
      }

      this.salaireUsers = myArray
    },
    async deleteAllUsers(){
      //Uniquement pour le compte BLP Test. Au cas où...
      if (this.agenceId != "" && this.agenceId == "612f5796734032249c6f0193") {
        let usersInApp = []

        await this.$axios.get('users/allInAgence/' + this.agenceId)
        .then(res => {
          usersInApp = res.data
        })
        .catch(err => {
          this.errors.push(err)
        })

        let arrayOfPromises = []
        for (const user of usersInApp) {
          arrayOfPromises.push(
            this.$axios.delete('users/' + user._id)
            .catch(err => this.errors.push(err))
          )
        }

        await Promise.all(arrayOfPromises)
        this.alert("Utilisateurs existants supprimés, prêt pour importation")
      }
    },
  }
}
</script>


<template>
  <div class="importer">
    <div class="importer-menu">
      <div v-for="(item, index) in steps" :key="item.ref" class="importer-menu-item" v-bind:class="{ 'importer-menu-item-selected': step >= index }" @click="clickToStep(index)">
          <div v-if="index != 0" class="importer-menu-item-bar"></div>
          <div class="importer-menu-item-circle">
            {{item.ref}}
            <div v-if="step == index" class="importer-menu-item-circle-label">{{item.name}}</div>
          </div>
      </div>
    </div>

    <div class="importer-screenDisplayed">
      <div class="importer-parcours" v-bind:style="{ left: computedOffset }">

        <!------------------>
        <!--    Page 0    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-0">
            <div class="importer-parcours-page-content-0-main">
              <select v-model="agenceId">
                <option value="">Sélectionner l'agence à importer</option>
                <option v-for="item in agences" :key="item._id" :value="item._id">{{ item.name }}</option>
              </select>
              <Spinner v-if="loading" />
            </div>
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(0)" >Valider</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 1    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-1">
            <Section text="Tâches non facturables">
              <template v-slot:body>
                <input type="file" id="nonFactImport" name="nonFactImport" accept=".json" @change="loadFile($event, 'nonFact')">
                <div class="importer-parcours-page-content-1-miniPage">
                  <div class="importer-parcours-page-content-1-miniPage-line" v-for="(item, index) in nonFact" :key="item._id">
                    <div class="importer-parcours-page-content-1-miniPage-line-name">{{item.nom}}</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-arrow material-icons">arrow_right_alt</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-value">
                      <select @change="copyOrigin('nonFactNew',$event.target.value, item.nom)" :id="item.nom" v-model="nonFact[index].bound">
                        <option value="">--</option>
                        <option v-for="appItem in nonFactApp" :key="appItem._id" :value="appItem._id">{{ appItem.name }}</option>
                        <option v-for="newItem in nonFactNew" :key="newItem._id" :value="newItem._id">{{ newItem.name }}</option>
                        <option :value="nonFactNew.length" v-if="nonFactNew.find(e => e.name == item.nom) == undefined">> Ajouter ce label</option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
            <Section text="Absences">
              <template v-slot:body>
                <input type="file" id="absencesImport" name="absencesImport" accept=".json" @change="loadFile($event, 'absences')">
                <div class="importer-parcours-page-content-1-miniPage">
                  <div class="importer-parcours-page-content-1-miniPage-line" v-for="(item, index) in absences" :key="item._id">
                    <div class="importer-parcours-page-content-1-miniPage-line-name">{{item.nom}}</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-arrow material-icons">arrow_right_alt</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-value">
                      <select @change="copyOrigin('absencesNew',$event.target.value, item.nom)" :id="item.nom" v-model="absences[index].bound">
                        <option value="">--</option>
                        <option v-for="appItem in absencesApp" :key="appItem._id" :value="appItem._id">{{ appItem.name }}</option>
                        <option v-for="newItem in absencesNew" :key="newItem._id" :value="newItem._id">{{ newItem.name }}</option>
                        <option :value="absencesNew.length" v-if="absencesNew.find(e => e.name == item.nom) == undefined">> Ajouter ce label</option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
            <Section text="Types de frais">
              <template v-slot:body>
                <input type="file" id="fraisImport" name="fraisImport" accept=".json" @change="loadFile($event, 'frais')">
                <div class="importer-parcours-page-content-1-miniPage">
                  <div class="importer-parcours-page-content-1-miniPage-line" v-for="(item, index) in frais" :key="item._id">
                    <div class="importer-parcours-page-content-1-miniPage-line-name">{{item.nom}}</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-arrow material-icons">arrow_right_alt</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-value">
                      <select @change="copyOrigin('fraisNew',$event.target.value, item.nom)" :id="item.nom" v-model="frais[index].bound">
                        <option value="">--</option>
                        <option v-for="appItem in fraisApp" :key="appItem._id" :value="appItem._id">{{ appItem.name }}</option>
                        <option v-for="newItem in fraisNew" :key="newItem._id" :value="newItem._id">{{ newItem.name }}</option>
                        <option :value="fraisNew.length" v-if="fraisNew.find(e => e.name == item.nom) == undefined">> Ajouter ce label</option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(1)" >Valider</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 2    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2">
            <Section text="Labels des phases">
              <template v-slot:body>
                <input type="file" id="contractualisesImport" name="contractualisesImport" accept=".json" @change="loadFile($event, 'contractualises')">
                <div class="importer-parcours-page-content-2-main">
                  <div class="importer-parcours-page-content-1-miniPage-line" v-for="(item, index) in phasesLabels" :key="item._id">
                    <div class="importer-parcours-page-content-1-miniPage-line-name">{{item.nom}}</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-arrow material-icons">arrow_right_alt</div>
                    <div class="importer-parcours-page-content-1-miniPage-line-value">
                      <select @change="copyPhaseLabel($event.target.value, item.nom, )" :id="item.nom" v-model="phasesLabels[index].bound">
                        <option value="">--</option>
                        <option v-for="appItem in phaseLabelsByType(0)" :key="appItem._id" :value="appItem._id">{{ appItem.name }}</option>
                        <option value="add0" v-if="phasesLabelsNew.find(e => e.name == item.nom && e.type == 0) == undefined">> Ajouter ce label</option>
                        <option value="" >-------------</option>
                        <option v-for="appItem in phaseLabelsByType(1)" :key="appItem._id" :value="appItem._id">{{ appItem.name }}</option>
                        <option value="add1" v-if="phasesLabelsNew.find(e => e.name == item.nom && e.type == 1) == undefined">> Ajouter ce label</option>
                        <option value="" >-------------</option>
                        <option v-for="appItem in phaseLabelsByType(2)" :key="appItem._id" :value="appItem._id">{{ appItem.name }}</option>
                        <option value="add2" v-if="phasesLabelsNew.find(e => e.name == item.nom && e.type == 2) == undefined">> Ajouter ce label</option>
                        <option value="" >-------------</option>
                        <option v-for="newItem in phasesLabelsNew" :key="newItem._id" :value="newItem._id">{{newItem.type}} - {{ newItem.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(2)" >Valider</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 3    -->
        <!------------------>

        <!-- Détail d'un projet -->
        <Modale v-if="isModaleProjetVisible" @close="closeModale">
          <template v-slot:header>
              <span>{{modaleInfos}}</span>
          </template>
          <template v-slot:body>
            <div class="modale-projet">
              <div v-for="item in phasesProjet(modaleInfos)" :key="item.name" class="modale-projet-line">
                <div class="modale-projet-line-name">{{item.name}}</div>
                <div>{{updateMontant(item.montant).str}} €</div>
              </div>
            </div>
          </template>
        </Modale>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2" v-if="!this.loading">
            <Section text="Projets et contrats">
              <template v-slot:body>
                <!-- <input type="file" id="contractualisesImport" name="contractualisesImport" accept=".json" @change="loadFile($event, 'contractualises')"> -->
                <div class="importer-parcours-page-content-3-main">
                  <div class="importer-parcours-page-content-3-main-line" v-for="item in computedProjets" :key="item.name"  @click="showModale('projet', item.name)">
                    <div class="importer-parcours-page-content-3-main-line-name">{{item.name}} :</div>
                    <div class="importer-parcours-page-content-3-main-line-value">{{updateMontant(item.montant).str}} €</div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <div v-else>
            <Spinner/>
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(3)" >Importer {{computedProjets.length}} projets</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 4    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2" v-if="!this.loading">
            <Section text="Imports des lignes de facturation">
              <template v-slot:body>
                <input type="file" id="facturesImport" name="facturesImport" accept=".json" @change="loadFile($event, 'factureLines')">
                <div class="importer-parcours-page-content-4-main">
                  <div v-for="item in computedProjetsFactured" :key="item.name" class="importer-parcours-page-content-4-main-projet">
                    <div class="importer-parcours-page-content-4-main-projet-title">{{item.name}} - ({{updateMontant(item.montant).str}} €ht)</div>
                    <div class="importer-parcours-page-content-4-main-projet-line" v-for="facture in facturesLinesByProjet(item.name)" :key="JSON.stringify(facture)">
                      <div class="importer-parcours-page-content-4-main-projet-line-item">Facture n°: {{facture.numero}}</div>
                      <div class="importer-parcours-page-content-4-main-projet-line-item">{{facture.date.toLocaleString("fr-FR", {day: "2-digit", month: "long", year: "numeric"})}}</div>
                      <div class="importer-parcours-page-content-4-main-projet-line-item">{{facture.nomPhase}}</div>
                      <div class="importer-parcours-page-content-4-main-projet-line-number">{{facture.pourcentage}} %</div>
                      <div class="importer-parcours-page-content-4-main-projet-line-number">{{updateMontant(facture.montant).str}} €ht</div>
                      <div class="importer-parcours-page-content-4-main-projet-line-number">{{facture.tva}} % TVA</div>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <div v-else>
            <Spinner/>
            <div style="text-align:center; width: 100%;">
              Factures : {{facturesCount}} | Lignes : {{linesCount}}
            </div>
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(4)">Importer {{factureLines.length}} lignes</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 5    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2">
            <Section text="Imports des utilisateurs">
              <template v-slot:body>
                <div>
                  <input type="file" id="salaireUsersImport" name="salaireUsersImport" accept=".json" @change="loadFile($event, 'salaireUsers')">
                  <button @click="deleteAllUsers">Supprimer tous les utilisateurs existants en base de données</button>
                </div>
                <div class="importer-parcours-page-content-5-main">
                  <div class="importer-parcours-page-content-5-main-user" v-for="(user, index) in users" :key="user.email">
                    <div class="importer-parcours-page-content-5-main-user-line">
                      <span>{{user.name}} {{user.surname}}</span>
                      <span>{{user.email}}</span>
                      <select name="role" id="role" v-model="users[index].roleId">
                        <option value="">--</option>
                        <option v-for="(role) in rolesApp" :key="role._id" :value="role._id">{{role.name}}</option>
                      </select>
                      <span v-for="item in user.salaire" :key="item.date.toISOString()">{{item.date.toLocaleString("fr-FR", {day: "2-digit", month: "2-digit", year: "numeric"})}} : {{item.val}} €</span>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(5)">Importer {{users.length}} utilisateurs</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 6    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2" v-if="!this.loading">
            <Section text="Imports des temps passés">
              <template v-slot:body>
                <input type="file" id="tempsFraisPrestasImport" name="tempsFraisPrestasImport" accept=".json" @change="loadFile($event, 'tempsFraisPrestas')">
                <div class="importer-parcours-page-content-6-main">
                  <div class="importer-parcours-page-content-6-main-left">
                    <div v-for="item in computedTempsParProjet" :key="item._id" class="importer-parcours-page-content-6-main-left-line">
                      <div>{{item.projet}}</div>
                      <div>{{item.phase}}</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{item.jours}} j.</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{item.heures}} h.</div>
                    </div>
                    <div class="importer-parcours-page-content-6-main-right-line importer-parcours-page-content-6-main-right-line-total">
                      <div>Total :</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{computedTotal.joursProjets}} j.</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{computedTotal.heuresProjets}} h.</div>
                    </div>
                  </div>
                  <!-- <div style="flex:1;"></div> -->
                  <div class="importer-parcours-page-content-6-main-right">
                    <div v-for="item in computedTempsParUser" :key="item._id" class="importer-parcours-page-content-6-main-right-line">
                      <div>{{item.name}}</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{item.jours}} j.</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{item.heures}} h.</div>
                    </div>
                    <div class="importer-parcours-page-content-6-main-right-line importer-parcours-page-content-6-main-right-line-total">
                      <div>Total :</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{computedTotal.joursUsers}} j.</div>
                      <div class="importer-parcours-page-content-6-main-left-line-align">{{computedTotal.heuresUsers}} h.</div>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <Spinner v-else />
          <div style="text-align:center; width: 100%;">
            Lignes importées : {{linesCount}}
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div>Erreurs : </div>
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(6)" v-if="computedTotal.joursProjets == computedTotal.joursUsers && computedTotal.heuresProjets == computedTotal.heuresUsers">
              Importer les temps
            </div>
            <div class="importer-parcours-page-footer-validateButton" v-else>Totaux non cohérents</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 7    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2" v-if="!this.loading">
            <Section text="Imports des notes de frais">
              <template v-slot:body>
                <div class="importer-parcours-page-content-7-main">
                  <div v-for="(item, index) in computedNdf" :key="index" class="importer-parcours-page-content-7-main-line">
                    <div> {{item.date.toLocaleString("fr-FR", {day: "2-digit", month: "2-digit", year: "numeric"})}} </div>
                    <div> {{item.projet}} </div>
                    <div> {{item.phase}} </div>
                    <div> {{item.user}} </div>
                    <div> {{item.objet}} </div>
                    <div> {{item.type}} </div>
                    <div style="justify-self: flex-end;"> {{updateMontant(item.montant, 2).str}} € </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <Spinner v-else />
          <div style="text-align:center; width: 100%;">
            Lignes importées : {{linesCount}}
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(7)">Importer {{computedNdf.length}} notes de frais pour un total de {{updateMontant(computedNdf.reduce((acc, val) => acc + val.montant, 0), 2).str}} €</div>
          </div>
        </div>

        <!------------------>
        <!--    Page 8    -->
        <!------------------>

        <div class="importer-parcours-page">
          <div class="importer-parcours-page-content-2" v-if="!this.loading">
            <Section text="Imports des prestations extérieures">
              <template v-slot:body>
                <div class="importer-parcours-page-content-7-main">
                  <div v-for="(item, index) in computedNdp" :key="index" class="importer-parcours-page-content-7-main-line">
                    <div> {{item.date.toLocaleString("fr-FR", {day: "2-digit", month: "2-digit", year: "numeric"})}} </div>
                    <div> {{item.projet}} </div>
                    <div> {{item.phase}} </div>
                    <div></div>
                    <div> {{item.objet}} </div>
                    <div> {{item.type}} </div>
                    <div style="justify-self: flex-end;"> {{updateMontant(item.montant, 2).str}} € </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
          <Spinner v-else />
          <div style="text-align:center; width: 100%;">
            Lignes importées : {{linesCount}}
          </div>
          <div class="importer-parcours-page-footer">
            <div class="importer-parcours-page-footer-errors" v-if="errors.length">
              <div v-for="item in errors" :key="item">{{item}}</div>
            </div>
            <div class="importer-parcours-page-footer-validateButton" @click="pageValidation(8)">Importer {{computedNdp.length}} prestations extérieures pour un total de {{updateMontant(computedNdp.reduce((acc, val) => acc + val.montant, 0), 2).str}} €</div>          </div>
        </div>
      </div>

    </div>

  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.importer{

  &-menu{
    display: flex;
    justify-content: space-between;
    margin: 30px 0 60px 0;

    &-item{
      display: flex;
      align-items: center;
      flex:1;

      &:nth-child(1){
        flex: 0;
      }

      &-circle{
        height: 37px;
        width:  37px;
        border-radius: 100%;
        background-color: $black;
        text-align: center;
        line-height: 37px; //Same as height
        color: white;
        @include myFont;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;

        &-label{
          color: $main;
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          text-align: center;
        }
      }

      &-bar{
        flex:1;
        border: 2px solid $black;
        height: 0px;
      }

      &-selected{
        & > .importer-menu-item-circle{
          background-color: $main;
        }

        & > .importer-menu-item-bar{
          border-color: $main ;
        }
      }
    }
  }

  &-screenDisplayed{
    overflow-x: hidden;
    position: relative;
    height: 470px;
  }

  &-parcours{
    display: grid;
    grid-template-columns: repeat(9, 100%);
    position: relative;
    left: 0;
    transition: all 0.7s ease;
    height: 100%;

    &-page{
      @include myBlock;
      justify-self: center;
      align-self: center;
      width: 96%;
      height: 96%;
      display: flex;
      flex-direction: column;

      &-content{

        &-0{
          flex: 1;
          padding: 15px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 30px;
          column-gap: 30px;
          row-gap: 20px;

          &-main{
            display: flex;
            flex-direction: column;
            align-items: center;
            grid-column: 1 / span 3;
          }
        }

        &-1{
          flex: 1;
          padding: 15px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 30px;
          column-gap: 30px;
          row-gap: 20px;

          &-miniPage{
            margin: 20px 0 0 0;

            &-line{
              display: grid;
              grid-template-columns: 45% 1fr 45%;
              @include myFont;
              font-size: 13px;
              margin: 5px 0 0 0;
              
              &-name{
                @include monoline;
              }

              &-arrow{
                margin-top: -2px;
                justify-self: center;
              }

              &-value > select{
                width: 100%;
              }
            }
          }
        }

        &-2{
          flex: 1;
          padding: 15px;

          &-main{  
            margin: 20px 0 0 0;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-auto-rows: 30px;
            column-gap: 70px;
            row-gap: 00px;
          }
        }

        &-3{
          &-main{
            margin: 20px 0 0 0;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            column-gap: 70px;
            row-gap: 0px;
            width: 100%;

            &-line{
              display: flex;
              justify-content: space-between;
              @include myFont;
              font-size: 13px;
              padding: 5px;
              margin: 1px 0;
              border: white solid 1px;
              border-radius: 5px;
              cursor: pointer;
              
              &:hover{
                border: $main solid 1px;
                background-color: $main-lighter;
              }

              &-name{
                @include monoline;
                width: 200px;
              }

              &-value{
                width: 80px;
                text-align: right;
              }
            }
          }
        }

        &-4{
          &-main{
            margin: 20px 0 0 0;
            display: flex;
            flex-direction: column;

            &-projet{
              margin: 0 0 10px 0;
              &-title{
                @include myFont;
                color: $main;
                font-size: 14px;
                font-weight: 600;
              }

              &-line{
                display: grid;
                grid-template-columns: 200px 150px 300px repeat(4, 120px);

                &-item{
                  @include myFont;
                  font-size: 13px;
                  color: $black-bolder;
                }

                &-number{
                  @include myFont;
                  font-size: 13px;
                  color: $black-bolder;
                  justify-self: flex-end;
                }
              }
            }
            
          }
        }

        &-5{
          &-main{
            margin: 20px 0 0 0;
            display: flex;
            flex-direction: column;

            &-user{
              margin: 0 0 10px 0;

              &-line{
                display: grid;
                grid-template-columns: repeat(2, 220px) 150px repeat(4, 130px);
                column-gap: 25px;

                & *{
                  @include myFont;
                  font-size: 13px;
                  color: $black-bolder;
                }
              }
            }
            
          }
        }

        &-6{
          &-main{
            margin: 20px 0 0 0;
            display: flex;
            justify-content: space-between;
            width: 100%;

            &-left{
              flex: 1;

              &-line{
                display: grid;
                grid-template-columns: repeat(2, 200px) repeat(2, 50px);

                & *{
                  @include myFont;
                  color: $black-bolder;
                  margin-right: 3px;
                  font-size: 13px;
                }

                &-align{
                  justify-self: flex-end;
                }
              }
            }

            &-right{
              flex: 1;

              &-line{
                display: grid;
                grid-template-columns: repeat(1, 400px) repeat(2, 50px);

                & *{
                  @include myFont;
                  color: $black-bolder;
                  margin-right: 3px;
                  font-size: 13px;
                }

                &-align{
                  justify-self: flex-end;
                }

                &-total{
                  margin: 10px 0 0 0;
                  padding: 5px 0 0 0;
                  border: 1px $black-bold solid;
                  border-width: 1px 0 0 0;
                }
              }
            }
          }
        }

        &-7{
          &-main{
            margin: 20px 0 0 0;
            width: 100%;

            &-line{
              display: grid;
              grid-template-columns: 100px 150px 150px 250px 1fr 200px 80px;
              color: $black-bolder;
              @include myFont;
              font-size: 13px;
            }
          }
        }
      }

      &-footer{
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &-errors{
          @include myFont;
          color: $alert;
          font-size: 13px;
          margin: 15px;
        }

        &-validateButton{
          @include myButton;
        }
      }
    }
  }

}

.modale{
  &-projet{
    &-line{
      display: flex;
      justify-content: space-between;

      &-name{
        @include monoline;
      }
    }
  }
}

</style>
